
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/couriers-protection",
      function () {
        return require("private-next-pages/newsroom/couriers-protection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/couriers-protection"])
      });
    }
  